export const orderlistMenuRouter = [{
  path: 'order/list',
  icon: ' iconfont iconorder',
  name: 'orderCount',
  title: '工单统计',
  component: () => import('@/views/gip/order/list.vue')
}]



// WEBPACK FOOTER //
// ./src/router/order/orderlist.js